const REQUEST_DEVICE_COMMAND = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_DEVICE_COMMAND = (state, { body }) => {
  state.status = "success";
  state.DeviceCommand = body;
};

const FAILURE_REQUEST_DEVICE_COMMAND = state => {
  state.status = "failure";
};

const REQUEST_UPDATE_DEVICE_COMMAND = state => {
  state.statusUpdate = "fetching";
};

const SUCCESS_REQUEST_UPDATE_DEVICE_COMMAND = state => {
  state.statusUpdate = "success";
};

const FAILURE_REQUEST_UPDATE_DEVICE_COMMAND = state => {
  state.statusUpdate = "failure";
};

const REQUEST_CREATE_DEVICE_COMMAND = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_CREATE_DEVICE_COMMAND = state => {
  state.statusCreate = "success";
};

const FAILURE_REQUEST_CREATE_DEVICE_COMMAND = state => {
  state.statusCreate = "failure";
};

export default {
  REQUEST_DEVICE_COMMAND,
  SUCCESS_REQUEST_DEVICE_COMMAND,
  FAILURE_REQUEST_DEVICE_COMMAND,
  REQUEST_UPDATE_DEVICE_COMMAND,
  SUCCESS_REQUEST_UPDATE_DEVICE_COMMAND,
  FAILURE_REQUEST_UPDATE_DEVICE_COMMAND,
  REQUEST_CREATE_DEVICE_COMMAND,
  SUCCESS_REQUEST_CREATE_DEVICE_COMMAND,
  FAILURE_REQUEST_CREATE_DEVICE_COMMAND,
};
